import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { BaseService } from './base.service';

interface UploadFileS3Result {
  success: boolean;
  path: string;
  url: string;
  fileName: string;
  contentType: string;
  fileBytes: any;
}

@Injectable({
  providedIn: 'root'
})

export class FileUploadService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  uploadFile(file: File) {
    const formData: any = new FormData();
    const params = new HttpParams();
    const options = { params, reportProgress: true, observe: 'events' };

    formData.append('request', file);
    return this.http.post(`${this.urlApi}/upload`, formData, { reportProgress: true, observe: 'events' }).toPromise();
  }

  uploadIuguFile(file: File, category: number, accessId: number): Observable<UploadFileS3Result> {
    const formData = new FormData();
    formData.append('request', file);
    formData.append('category', category.toString());
    formData.append('AccessId', accessId.toString());

    return this.http.post<UploadFileS3Result>(`${this.urlApi}/IuguUpload`, formData);
  }

  removeFileFromS3(path: string) {
    return this.http.post<UploadFileS3Result>(
      `${this.urlApi}/remove-file?path=${encodeURIComponent(path)}`,
      {}
    );
  }

  updateFile(payload: { identification: string; selfie: string }) {
    return this.http.put(`${this.urlApi}/update-file`, payload);
  }

}

